import Firebase, { firestore } from 'firebase/app'
import 'firebase/database';

let config = {
  databaseURL: wwfconfigs.FIREBASE
}

Firebase.initializeApp(config);

export default {
   database: Firebase.database()
}


// WEBPACK FOOTER //
// ./src/firebase.js